import React, { useState } from "react";
import { Form, Typography } from "antd";
import FormInput from "../FormInput";
import ButtonComponent from "../Button/Button";

import { RightOutlined, LockOutlined, CheckOutlined, CloseOutlined } from '@ant-design/icons';

const { Text } = Typography;


const CreatePassword = ({ ...props }) => {
    const [passwordValidation, setPasswordValidation] = useState({
        hasUpperCase: false,
        hasLowerCase: false,
        hasNumber: false,
        hasSpecialChar: false,
        hasValidLength: false
    });

    const validatePasswordRequirements = (value) => {
        if (!value) {
            setPasswordValidation({
                hasUpperCase: false,
                hasLowerCase: false,
                hasNumber: false,
                hasSpecialChar: false,
                hasValidLength: false
            });
            return;
        }

        setPasswordValidation({
            hasUpperCase: /[A-Z]/.test(value),
            hasLowerCase: /[a-z]/.test(value),
            hasNumber: /\d/.test(value),
            hasSpecialChar: /[#@%&!^*.,_+=?]/.test(value),
            hasValidLength: value.length >= 8 && value.length <= 20
        });
    };

    const handleValuesChange = (changedValues) => {
        if (changedValues.newPassword !== undefined) {
            validatePasswordRequirements(changedValues.newPassword);
        }
    };

    return (
        <Form layout="vertical" className="inputBoxStyle" onFinish={props.onFinish} onValuesChange={handleValuesChange} requiredMark={true}>
            <FormInput
                label="New Password"
                name="newPassword"
                type="password"
                placeholder="Enter New Password"
                prefix={<LockOutlined />}
                rules={[
                    { required: true, message: "New Password is required" },
                    // { validator: props.validatePassword }
                ]}
            />

            <FormInput
                label="Confirm Password"
                name="confirmPassword"
                type="password"
                placeholder="Enter Confirm Password"
                prefix={<LockOutlined />}
                rules={[
                    { required: true, message: "Confirm Password is required" },
                    ({ getFieldValue }) => ({
                        validator(_, value) {
                            if (!value || getFieldValue("newPassword") === value) {
                                return Promise.resolve();
                            }
                            return Promise.reject(new Error("Passwords do not match"));
                        }
                    })
                ]}
            />
            <div className="requirements">
                <p>Password Requirements:</p>
                <ul style={{ padding: 0 }}>
                    <li style={{ color: passwordValidation.hasUpperCase ? '#52c41a' : '#d9d9d9', opacity: passwordValidation.hasUpperCase ? 1 : 0.5 }}>
                        {passwordValidation.hasUpperCase ? <CheckOutlined /> : <CloseOutlined />} At least 1 capital letter
                    </li>
                    <li style={{ color: passwordValidation.hasLowerCase ? '#52c41a' : '#d9d9d9', opacity: passwordValidation.hasLowerCase ? 1 : 0.5 }}>
                        {passwordValidation.hasLowerCase ? <CheckOutlined /> : <CloseOutlined />} At least 1 small letter
                    </li>
                    <li style={{ color: passwordValidation.hasNumber ? '#52c41a' : '#d9d9d9', opacity: passwordValidation.hasNumber ? 1 : 0.5 }}>
                        {passwordValidation.hasNumber ? <CheckOutlined /> : <CloseOutlined />} At least 1 number
                    </li>
                    <li style={{ color: passwordValidation.hasSpecialChar ? '#52c41a' : '#d9d9d9', opacity: passwordValidation.hasSpecialChar ? 1 : 0.5 }}>
                        {passwordValidation.hasSpecialChar ? <CheckOutlined /> : <CloseOutlined />} At least 1 special character (#, @, %, !, &)
                    </li>
                    <li style={{ color: passwordValidation.hasValidLength ? '#52c41a' : '#d9d9d9', opacity: passwordValidation.hasValidLength ? 1 : 0.5 }}>
                        {passwordValidation.hasValidLength ? <CheckOutlined /> : <CloseOutlined />} 8–20 characters length
                    </li>
                </ul>
            </div>
            <Form.Item>
                <ButtonComponent
                    text={"Save And Proceed"}
                    htmlType="submit"
                    className="login-card-new__button"
                    icon={<RightOutlined />}
                    loading={props.loading}
                    disabled={
                        !passwordValidation.hasUpperCase ||
                        !passwordValidation.hasLowerCase ||
                        !passwordValidation.hasNumber ||
                        !passwordValidation.hasSpecialChar ||
                        !passwordValidation.hasValidLength
                    }
                />
            </Form.Item>
        </Form>
    )
}

export default CreatePassword;